import { Link } from "react-router-dom";
import { ChatText, Notebook } from "@phosphor-icons/react";

const TYPE_LABELS = { scheduling: "Scheduling", call_off: "Call-off", visit_note: "Visit note", client_concern: "Client concern", caregiver_issue: "Caregiver issue", supply_need: "Supply need", message: "Message", urgent: "URGENT", other: "Note", note: "Note", shift_wrap: "Visit note", concern: "Concern" };

export default function PersonNotesTrail({ notes = [], emptyText = "No notes yet — use the quick note on the dashboard and match it to this person.", testid = "person-notes-trail", onToggleShare }) {
  const sorted = [...notes].sort((a, b) => String(b.date || "").localeCompare(String(a.date || "")));
  return (
    <div className="mb-6 rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={testid}>
      <p className="flex items-center gap-2 font-heading text-sm font-semibold text-stone-900">
        <ChatText size={16} className="text-primary" /> Notes
        {sorted.length > 0 && <span className="rounded-full bg-stone-100 px-2 py-0.5 text-[10px] font-bold text-stone-500">{sorted.length}</span>}
      </p>
      {sorted.length === 0 ? (
        <p className="mt-2 text-xs text-stone-400">{emptyText}</p>
      ) : (
        <div className="mt-3 space-y-2">
          {sorted.map((n) => (
            <div key={n.id} className="rounded-lg border border-stone-100 bg-accent/20 px-4 py-2.5" data-testid={`${testid}-row-${n.id}`}>
              <div className="flex flex-wrap items-center gap-1.5">
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-bold text-primary">{TYPE_LABELS[n.type] || n.type || "Note"}</span>
                {(n.tags || []).map((t) => (
                  <span key={t} className="rounded-full bg-stone-100 px-2 py-0.5 text-[10px] font-semibold text-stone-500" data-testid={`${testid}-tag-${n.id}-${t}`}>#{t}</span>
                ))}
                {/^\d{4}-\d{2}-\d{2}$/.test(String(n.date || "").slice(0, 10)) ? (
                  <Link to={`/calendar?focus=${String(n.date).slice(0, 10)}`} className="ml-auto text-[10px] font-medium text-primary hover:underline" data-testid={`${testid}-cal-${n.id}`}>
                    {String(n.date).slice(0, 10)}{n.by ? ` · ${n.by}` : ""}
                  </Link>
                ) : (
                  <span className="ml-auto text-[10px] text-stone-400">{String(n.date || "").slice(0, 10)}{n.by ? ` · ${n.by}` : ""}</span>
                )}
                {onToggleShare && n.type !== "shift_wrap" && (
                  <button onClick={() => onToggleShare(n, !n.shared)}
                    className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${
                      n.shared ? "border-primary/40 bg-primary/10 text-primary" : "border-stone-200 text-stone-400 hover:border-primary/40 hover:text-primary"
                    }`}
                    title={n.shared ? "Visible in the caregiver notebook — click to remove" : "Office-only — click to share with this client's caregivers"}
                    data-testid={`${testid}-share-${n.id}`}>
                    <Notebook size={11} /> {n.shared ? "In notebook" : "Share to notebook"}
                  </button>
                )}
              </div>
              <p className="mt-1 text-sm leading-relaxed text-stone-700">{n.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
